import { addLoginAbortedCallback, ngFrameworkLoaded } from "@/shared/ng/ng-integration";
import { watch } from "vue";
import { useAuthStore } from "@/shared/stores/use-auth-store";
import { PATHS } from "@/router/paths";
import { storeToRefs } from "pinia";

export default function useTokenAuth() {
    const authStore = useAuthStore();
    const { isTokenAvailable } = storeToRefs(authStore);
    const showLogin = (loginFailureRedirect: string = PATHS.HOME, loginAbortRedirect: string = PATHS.HOME) =>
        new Promise(async (res) => {
            const unwatch = watch(
                () => isTokenAvailable,
                () => {
                    if (isTokenAvailable.value) {
                        unwatch();
                        res(true);
                    } else {
                        // router cannot be used here because inject() can only be used inside setup() or functional components
                        window.location.href = loginFailureRedirect;
                    }
                },
            );

            if (isTokenAvailable.value) {
                unwatch();
                res(true);
                return;
            }

            await ngFrameworkLoaded();
            ng_fw.showLogin();
            // addLoginAbortedCallback(() => {
            //     window.location.href = loginAbortRedirect;
            // });
        });
    return {
        showLogin,
    };
}
